import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=7b670435"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=7b670435&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports